function safeJsonReviver(key: string, value: any) {
  if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
    return undefined;
  }
  return value;
}

export function getSafeObjectFromUrl<T>(
  searchParams: URLSearchParams,
  paramName: string,
): T {
  const raw = searchParams.get(paramName);
  if (!raw) {
    throw new Error(`Missing parameter: ${paramName}`);
  }
  let decoded: string;
  try {
    decoded = decodeURIComponent(raw);
  } catch (e) {
    throw new Error(`Invalid URL encoding for parameter: ${paramName}`);
  }

  try {
    return JSON.parse(decoded, safeJsonReviver);
  } catch (e) {
    throw new Error(`Invalid JSON for parameter: ${paramName}`);
  }
}
